/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import { TokenFormModel } from 'src/app/models/token.model';
import { environment } from 'src/environments/environment';
import { ProfileModel } from '../models/profile.model';
import { DataService } from './data.service';
import { FollowService } from './follow.service';
import { GetTranslationService } from './get-translation.service';
import { OneSignalService } from './one-signal.service';
import { ToastMachineService } from './toast-machine.service';
import { CentrifugeService } from './centrifuge.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isLogged = false;
  tokenForm: TokenFormModel = JSON.parse(localStorage.getItem('token'));
  profile: ProfileModel = null;
  registerToken: string = null;
  profileLoading: boolean = false; // <-- EKLENDİ

  constructor(
    private toaster: ToastMachineService,
    private http: HttpClient,
    private dataServ: DataService,
    private translateServ: TranslateService,
    private translator: GetTranslationService,
    private oneSignal: OneSignalService,
    private followServ: FollowService,
    private centrifugeServ: CentrifugeService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.control();

    if (this.isLogged) {
      this.followServ.getFollows();
    }
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  login(loginData: { username: string; password: string; hotel_id: number }) {
    return new Promise((resolve, reject) => {
      loginData.hotel_id =
        +localStorage.getItem('hotelId') || environment.hotelId;
      this.http.post(environment.URL + '/p_login', loginData).subscribe({
        next: async (resp: TokenFormModel) => {
          this.isLogged = true;
          this.tokenForm = resp;
          localStorage.setItem('token', JSON.stringify(resp));
          localStorage.setItem('centrifugeToken', resp.centrifuge_token);
          this.centrifugeServ.centrifuge.setToken(resp.centrifuge_token);
          try {
            this.centrifugeServ.centrifuge.connect();
          } catch {
            console.error(
              'There is an error occured while connecting to WebSocket'
            );
          }
          await this.getMe();
          try {
            this.oneSignal.oneSignalLogin();
          } catch {}
          this.followServ.getFollows();
          resolve(resp);
        },
        error: async (err) => {
          const error = await this.translator.getTranslate(
            err.error && err.error.message ? err.error.message : err.message
          );
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  async control() {
    this.tokenForm = JSON.parse(localStorage.getItem('token'));

    if (
      this.tokenForm &&
      dayjs(new Date(this.tokenForm.expire)).diff(new Date()) > 0 &&
      this.dataServ.rData &&
      this.tokenForm.hotel_id === this.dataServ.rData.id
    ) {
      this.isLogged = true;
    } else {
      this.profile = null;
      this.tokenForm = null;
      this.isLogged = false;
    }
  }

  async forgotPassword(email: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post(environment.baseURL + '/profile_forgot_password', {
          email,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          hotel_id: +localStorage.getItem('hotelId') || environment.hotelId,
        })
        .subscribe({
          next: async (resp) => {
            const MSG = await this.translator.getTranslate(
              'Check your email for reset password'
            );
            this.toaster.toastMachine(MSG, 'primary', 3000);
            resolve(true);
          },
          error: async (err) => {
            const error = await this.translator.getTranslate(
              err.error && err.error.message ? err.error.message : err.message
            );
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  getMe(): Promise<ProfileModel> {
    this.profileLoading = true; // <-- EKLENDİ
    return new Promise((resolve, reject) => {
      this.http
        .get(
          environment.apiURL +
            '/app_me' +
            (localStorage.getItem('centrifugeToken')
              ? ''
              : '?getCentrifugeToken=true')
        )
        .subscribe({
          next: async (resp: ProfileModel) => {
            if (resp.centrifuge_token) {
              localStorage.setItem('centrifugeToken', resp.centrifuge_token);
              this.centrifugeServ.centrifuge.setToken(resp.centrifuge_token);
              try {
                this.centrifugeServ.centrifuge.connect();
              } catch {
                console.error(
                  'There is an error occured while connecting to WebSocket'
                );
              }
            }
            this.profile = resp;
            this.profileLoading = false; // <-- EKLENDİ
            resolve(resp);
          },
          error: async (err) => {
            this.profileLoading = false; // <-- EKLENDİ
            console.log(err);

            const error = await this.translator.getTranslate(
              err.error && err.error.status ? err.error.status : err.message
            );
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  // POST : https://api.icibot.net/v2/app_login_with_token
  // {
  //     "hotel_id":2022,
  //     "token:"AtPSjQEQINaDg4yQcGGw8oQpxu2FL%2FXJASZOoLQ0yNBfv3gVN9mQAe0q79v37cL0"
  // }
  postWithToken() {
    // Token'ı tekrar encode ederek gönderiyoruz
    const encodedToken = encodeURIComponent(this.registerToken);
    return new Promise((resolve, reject) => {
      this.http
        .post(environment.baseURL + '/app_login_with_token', {
          hotel_id: +localStorage.getItem('hotelId') || environment.hotelId,
          token: encodedToken,
        })
        .subscribe({
          next: async (resp: TokenFormModel) => {
            this.isLogged = true;
            this.tokenForm = resp;
            localStorage.setItem('token', JSON.stringify(resp));
            localStorage.setItem('centrifugeToken', resp.centrifuge_token);
            this.centrifugeServ.centrifuge.setToken(resp.centrifuge_token);
            try {
              this.centrifugeServ.centrifuge.connect();
            } catch {
              console.error(
                'There is an error occured while connecting to WebSocket'
              );
            }
            await this.getMe();
            try {
              this.oneSignal.oneSignalLogin();
            } catch {}
            this.followServ.getFollows();
            this.router.navigate(['/' + (resp.route || 'home')], {
              queryParams: { register_token: null },
            });
            resolve(resp);
          },
          error: async (err) => {
            const error = await this.translator.getTranslate(
              err.error && err.error.message ? err.error.message : err.message
            );
            this.toaster.toastMachine(error, 'danger', 3000);

            reject(err);
          },
        });
    });
  }

  putMe(data: ProfileModel): Promise<any> {
    if (!data.password) {
      delete data.password;
    }

    return new Promise((resolve, reject) => {
      this.http.put(environment.apiURL + `/app_me/${data.id}`, data).subscribe({
        next: async (resp: ProfileModel) => {
          await this.getMe();
          const MSG = await this.translator.getTranslate('Successfuly Updated');
          this.toaster.toastMachine(MSG, 'primary', 3000);
          resolve(resp);
        },
        error: async (err) => {
          const error = await this.translator.getTranslate(
            err.error && err.error.message ? err.error.message : err.message
          );
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  location() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/my_location').subscribe({
        next: (resp) => {
          resolve(resp);
        },
        error: async (err) => {
          const error = await this.translator.getTranslate(
            err.error && err.error.message ? err.error.message : err.message
          );
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  createUser(form: {
    email: string;
    first_name: string;
    last_name: string;
    phone_no: string;
    password: string;
    passport_no: string;
    room_number: string;
    checkin_date: string;
    check_out_date: string;
    date_of_birth: string;
    terms_and_conditions: boolean;
  }) {
    return new Promise((resolve, reject) => {
      const DATA: ProfileModel = new ProfileModel();
      DATA.e_mail = form.email;
      DATA.id_no = form.passport_no;
      DATA.phone_no = form.phone_no;
      DATA.password = form.password;
      DATA.first_name = `${form.first_name ? form.first_name.split(' ') : ' '}`;
      DATA.last_name = form.last_name;
      DATA.hotel_id = this.dataServ.rData.id;
      DATA.locale = this.translateServ.defaultLang;
      DATA.room_no = form.room_number;
      DATA.entry_date = form.checkin_date || new Date();
      DATA.release_date = form.check_out_date || new Date();
      DATA.date_of_birth = form.date_of_birth || new Date();
      DATA.terms_and_conditions = form.terms_and_conditions;

      const UTC = dayjs(new Date()).utcOffset();

      // DATA.date_of_birth = dayjs(DATA.date_of_birth).set('hour', 0)
      //   .set('minute', 0).set('second', 0).set('millisecond', 0).add(UTC, 'minute').toDate();

      this.http.post(environment.baseURL + '/app_login', [DATA]).subscribe({
        next: async (resp) => {
          localStorage.setItem('token', JSON.stringify(resp));
          const MSG = await this.translator.getTranslate(
            'Successfully Registered'
          );
          this.toaster.toastMachine(MSG, 'primary', 3000);
          try {
            this.oneSignal.oneSignalLogin();
          } catch {}
          this.followServ.getFollows();
          resolve(resp);
        },
        error: async (err) => {
          console.error(err);
          const error = await this.translator.getTranslate(
            err.error && err.error.message ? err.error.message : err.message
          );
          const MSG = await this.translator.getTranslate(error);
          this.toaster.toastMachine(MSG, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  checkIn(newData: ProfileModel) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.baseURL + '/app_login', [newData]).subscribe({
        next: async (resp) => {
          if (!localStorage.getItem('token')) {
            localStorage.setItem('token', JSON.stringify(resp));
          }
          try {
            this.oneSignal.oneSignalLogin();
          } catch {}
          resolve(resp);
        },
        error: async (err) => {
          const error = await this.translator.getTranslate(
            err.error && err.error.message ? err.error.message : err.message
          );
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  logOut() {
    localStorage.removeItem('token');
    localStorage.removeItem('centrifugeToken');
    this.isLogged = false;
    this.profile = null;
    this.tokenForm = null;
    this.registerToken = null;

    if (this.activatedRoute.snapshot.queryParams['register_token']) {
      // Kullanıcıyı home'a yönlendir ve query parametrelerini temizle
      this.router
        .navigate(['/home'], {
          queryParams: { register_token: null },
          replaceUrl: true,
        })
        .then(() => {
          // Yönlendirme tamamlandıktan sonra sayfayı yenile
          window.location.reload();
        });
    }

    this.control(); // Yenilemeden dolayı gerek kalmaz
  }

  async deleteMe() {
    const PROF = new ProfileModel();

    PROF.e_mail = `deleted_${new Date().getTime()}@mail.com`;
    PROF.id = this.profile.id;

    await this.putMe(PROF);
    this.logOut();
  }
}
